<template>
  <div class="container-fluid gt-0" style="padding:0;overflow-x:hidden">
      <div style='text-align:center;font-size:18pt;margin:auto;width:auto;font-weight:bold'>
          USER MANAGEMENT</div>

      <div v-if="mode == 'add'" style='font-size:12pt'>
        <table style='width:40%;margin:auto'>
          <tr>
            <td> User Login</td><td>:</td>
              <td> <input type="text" class="input" v-model="login" size="30" maxsize="50"/> </td>
          </tr>
          <tr>
            <td>Name</td>
            <td>:</td>
              <td> <input type="text" class="input" v-model="name" size="30" maxsize="50"/> </td>
          </tr>
          <tr>
            <td> User Role </td>
            <td>:</td>
            <td>
              <select v-model="selected_role">
                <option v-for="k in userroles" :value="k.id" :key="k.id">
                  {{k.name}}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td> Multi Session</td>
            <td>:</td>
            <td>
              <select v-model="selected_multi">
                <option v-for="k in multisession" :value="k.id" :key="k.id">
                  {{k.name}}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td>Password</td>
            <td>:</td>
            <td><input type="password" class="input" v-model="password" size="12" maxsize="30"/></td>
          </tr>
          <tr>
            <td>Confirm Password</td>
            <td>:</td>
            <td><input type="password" class="input" v-model="r_password" size="12" maxsize="30"/></td>
          </tr>
        </table>
      </div>

      <div v-if="mode == 'browse'" class="table-responsive" style='font-size:10pt'>
        <table class="table table-striped table-bordered font-custom">
            <thead>
                <tr>
                    <th class="d-none d-md-block">CHECK</th>
                    <th v-for="h in brwheader" :key="h"> {{ h }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="myrow in brwdata" :key="myrow.cols[0]">
                    <td class="d-none d-md-block" style='text-align:center'>
			<input type="checkbox" :value="myrow.cols[0]" @click="do_checkbox(myrow.cols[0])" 
                          v-model="myrow.selected"/></td>
                    <td v-for="(c, idx) in myrow.cols" :key="c" class="colpad">
                      <template v-if="idx==8">
                         {{ filter_role(c) }}
                      </template>
                      <template v-if="idx==7">
                         {{ filter_multi(c) }}
                      </template>
                      <template v-if="idx < 7 || idx > 8">
                         {{ c }}
                      </template>
                    </td>
                </tr>
            </tbody>
        </table>

      </div>

      <div>
        <br>
        <div v-if="errormsg !=''" class="border mb-3" 
          style='color:red;background:yellow'>
          {{errormsg}}
        </div>

        <div v-if="mode == 'add'">
          <table style='width:10%;margin:auto;bottom-margin:10%'>
            <tr><td> 
              <button class="btn btn-primary btn-block mb-4" @click="do_add">
                Save</button>
              </td>
              <td>
              <button class="btn btn-primary btn-block mb-4" @click="changemode('browse')"> 
                Cancel</button>
              </td>
            </tr></table>
        </div>

        <div v-if="mode=='browse'" class="table-responsive">
          <table align="center">
          <tr>
            <td>
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('next')"> 
              Next</button></td>

            <td>
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('prev')"> 
              Prev</button></td>

            <td> 
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('first')"> 
              First</button></td>
            <td> 
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('last')"> 
              Last</button></td>

            <td style='width:30px'></td>

            <td class="d-none d-md-inline">
            <button class="btn btn-primary btn-block mb-4" @click="changemode('add')"> 
              Add</button></td>

            <td class="d-none d-md-inline"> 
              <button class="btn btn-primary btn-block mb-4" @click="show_update()"> 
              Update</button></td>

            <td class="d-none d-md-inline"> 
              <button class="btn btn-primary btn-block mb-4" @click="show_report()"> 
              LogReport</button></td>
          </tr></table>
        </div>
      </div>
  </div>

  <div class="modal" id="MODAL301" tabindex="-1" aria-labelledby="MODAL301Label" aria-hidden="true">
    <div class="modal-dialog" style="width:25rem">
      <div class="modal-content">
         <div class="modal-header" style='background: #9999FF;padding:2px'>
           <p class="modal-title">USER LOG REPORT</p>
           <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
         </div>

          <div class="modal-body">
          <div>
             REPORT PERIOD: 
             <select v-model="reportperiod">
               <option v-for="fld in report_lists" :value="fld.days" :key="fld.days">
                  {{ fld.name }} 
               </option>
             </select>
             &nbsp;
             &nbsp;
             &nbsp;
             &nbsp;
             <button type="button" data-bs-dismiss="modal" 
                 @click="get_report()">Get</button>
          </div>

        </div>
      </div>
    </div>
  </div>


  <div class="modal" id="MODAL101" tabindex="-1" aria-labelledby="MODAL101Label" aria-hidden="true">
    <div class="modal-dialog" style="width:25rem">
      <div class="modal-content">
        <div class="modal-header" style='background: #9999FF;padding:2px'>
          <p class="modal-title">FIELD UPDATE</p>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <table>
           <tr><td>LOGIN</td><td>:</td><td>{{login}}</td></tr>

           <tr><td>FIELDS</td><td>:</td><td>
           <select v-model="change" @change="do_chgfield()">
             <option v-for="fld in change_fields" :value="fld.id" :key="fld.id">
                {{ fld.name }} 
             </option>
           </select>
           <button v-if="change != 0" style='margin-left:10px' 
               type="button" data-bs-dismiss="modal" 
              @click="do_update()">Update</button>
           </td>
           </tr>

          <tr v-if="change == 1"><td>User Name</td><td>:</td><td>
             <input id="inpuser01" type="text" v-model="newdata"></td></tr>

          <tr v-if="change == 2"><td>status</td><td>:</td><td>
           <select v-model="newdata">
             <option v-for="fld in status_lists" :value="fld" :key="fld">
                {{ fld }} 
             </option>
           </select>
          </td>
          </tr>

          <tr v-if="change == 3"><td>User Role</td><td>:</td><td>
           <select v-model="selected_role">
             <option v-for="fld in userroles" :value="fld.id" :key="fld.id">
                {{ fld.name }} 
             </option>
           </select>
          </td>
          </tr>

          <tr v-if="change == 4"><td>Multi Session</td><td>:</td><td>
           <select v-model="selected_multi">
             <option v-for="fld in multisession" :value="fld.id" :key="fld.id">
                {{ fld.name }} 
             </option>
           </select>
          </td>
          </tr>

          <template v-if="change == 5">
          <tr><td>PASSWORD</td><td>:</td><td>
             <input id="inpuser02" type="password" v-model="password"
                placeholder="new password"></td></tr>
          <tr><td>CONFIRM</td><td>:</td><td>
             <input id="inpuser03" type="password" v-model="r_password"
                placeholder="confirm"></td></tr>
          </template>
          </table>

          <div v-if="errormsg !=''" class="border mb-3" 
              style='color:red;background:yellow'>
              {{errormsg}}
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import bootstrap from 'bootstrap/dist/js/bootstrap.js'
import sha256 from 'crypto-js/sha256'
import Base64 from 'crypto-js/enc-base64'

export default {
  name: 'KeyInput',
  props: {
    msg: String
  },
  mounted() {
    this.getconfig();
    this.getbrowse('first');
    this.fromdate = new Date() ;
  },
  computed: {
    title() {
      if (this.mode == "browse")
        return "KEY TABLES"
      else
        return "ADD KEY"

    },
    startseq() {
      let x = this.brwdata[0] ;
      if (! x) return 0 ;
      if (! x.cols) return 0 ;
      return x.cols[0] ;
    },
    userlogin() {
      return this.$store.getters.userlogin ;
    },
    curpage() {
      return this.$store.getters.curpage ;
    },
    targetobj() {
      for (let obj of this.brwdata) {
        if (obj.selected) 
          return parseInt(obj.cols[0]) ;
      }
      return 0 ;
    },
    targetrow() {
      var i = 0 ;
      for (let obj of this.brwdata) {
        i++ ;
        if (obj.selected) 
          return i ;
      }
      return 0 ;
    }
  },
  data() {
    return { 
      reportperiod : 7,
      showdata : 0,
      datalabel : 'label',
      change_fields : [ { id : 0, "name" : 'NONE' }, { id : 1, "name" : "User Name" },
                        { id : 2, "name" : 'Status' }, {id: 3, "name" : "User Role"},
                        { id : 4, "name" : 'MultiSession'}, { id : 5, "name" : "Password" } ],
      change : 0,
      status_lists : [ 'block', 'new', 'inactive', 'active' ],
      report_lists : [ { "name" : 'Last 1 week', "days" : 7 }, 
                       { "name" : "Last 30 days", "days" : 30 },
                       { "name" : 'Last 90 days', "days" :90 }, 
                       { "name" : "Last 1 Year", "days" : 365 },
                       { "name" : "All available", "days" : 10000 } ],
      mode : "browse",
      config : null,
      userroles : [ { id : 0, "name" : "NOTLOADED", "access" : 0 } ],
      newdata   : '',
      fromdate : null,
      selected_role: 0,
      selected_multi: 0,
      multisession : [ {id : 0, "name" : "Single"}, {id : 1, "name" : "Multi"} ],
      numoferr : 0,
      errormsg : '',
      login : '',
      brwheader : [ "id", "LOGIN", "NAME", "CREATEBY", "CREATEDATE", 
            "LASTMODBY", "LASTMODDATE", "MULTI", "ROLE", "Status" ],
      brwdata   : [ 
                    { "selected" : false,
                      "cols" : [ "0", "USER1", "USER ONE", "SYS",
                        "07/08/2023 10:00", "SYS", "07/08/2023 11:00", 0, 0, "inactive" ]
                    }
                  ],
      name : '',
      password : '',
      r_password: ''
    }
  },
  methods : {
     get_report() {
        var tar = this.targetrow ;
        if (tar == 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
        }
        tar-- ;

        var login = this.brwdata[tar].cols[1] ;
        let req = this.$store.getters.controller_url +
              "/prosw/CFG/usermgmt/getreport" + "?swapid=" + 
              this.$store.getters.controllerid + "&login=" + login + 
              "&period=" + this.reportperiod ;
        axios.get (req, {
            timeout: 10000,
            responseType: 'blob',
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (res) => {
           let FILE = window.URL.createObjectURL(new Blob([res.data]));
           var docUrl = document.createElement('a');
           docUrl.href = FILE;
           docUrl.setAttribute('download', login + "_log.csv");
           document.body.appendChild(docUrl);
           docUrl.click();
        }).catch ( (error) => { console.log(error) })
    },

    checkpassword(password) {
      let regex =
/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
        return regex.test(password) ;
    },
    filter_role(role) {
       for (var i = 0 ; i < this.userroles.length ; i++) {
         if (this.userroles[i].id == parseInt(role)) {
           return this.userroles[i].name ;
         }
       }
       return "none" ;
    },
    filter_multi(multi) {
       for (var i = 0 ; i < this.multisession.length ; i++) {
         if (this.multisession[i].id == parseInt(multi)) {
           return this.multisession[i].name ;
         }
       }
       return "none" ;
    },
    do_checkbox(seq) {
      for ( let r of this.brwdata ) {
        if (r.cols[0] != seq && r.selected) 
          r.selected = false ;
      }
    },
    do_chgfield() 
    {
        var tar = this.targetrow ;
        if (tar == 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
        }
  
        tar-- ;
        switch (this.change) {
        case 1 : 
          this.datalabel = "NAME" ;
          this.newdata = this.brwdata[tar].cols[2] ;
          break ;
        case 2 :
          this.datalabel = "STATUS" ;
          this.newdata = this.brwdata[tar].cols[9] ;
          break ;
        case 3 :
          this.datalabel = "USER ROLE" ;
          this.selected_role = parseInt(this.brwdata[tar].cols[8]) ;
          break ;
        case 4 :
          this.datalabel = "MULTI SESSION" ;
          this.selected_multi = parseInt(this.brwdata[tar].cols[7]) ;
          break ;
        }
    },
    do_update() {
       let req = this.$store.getters.controller_url +
        "/prosw/CFG/usermgmt/save?swapid=" + 
              this.$store.getters.controllerid + 
          "&seq=" + this.startseq + "&target=" + this.targetobj ;

        var tar = this.targetrow ;
        if (tar == 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
        }
  
        this.errormsg = '' ;

        tar-- ;
        switch (this.change) {
        case 0:
          this.erromsg = "no update" ;
          break ;
        case 1 : 
          this.datalabel = "NAME" ;
          if (this.newdata == this.brwdata[tar].cols[2])
            this.errormsg = "No Data Change" ; 
          if (this.newdata.length == 0)
            this.errormsg = "NAME can not blank" ;
          break ;
        case 2 :
          if (this.newdata == this.brwdata[tar].cols[9])
            this.errormsg = "No Data Change" ; 
          break ;
        case 3 :
          if (this.selected_role == parseInt(this.brwdata[tar].cols[8]))
            this.errormsg = "No Data Change" ; 
          else
            this.newdata = this.selected_role.toString() ;
          break ;
         case 4:
          if (this.newdata == this.brwdata[tar].cols[7])
            this.errormsg = "No Data Change" ; 
          else
            this.newdata = this.selected_multi.toString() ;
          break ;
         case 5:
           if ( this.password.length < this.config.passwordlen) {
             this.errormsg = 'PASSWORD LENGTH MIN ' +
                this.config.passwordlen + ' CHARS' ;
             break ;
           }

           if (this.config.passwordstrength) 
             if (! this.checkpassword(this.password)) {
                  this.errormsg = "Password must contain mix letter, number and special" ;
                  break ;
             }
           
           if (this.r_password != this.password) {
             this.errormsg = "password and confirmation not match" ;
             break ;
           }
           break ;
       }

       if (this.errormsg != '' ) return ;

       let formData = new FormData();
       let userid = this.brwdata[tar].cols[1] ;
       var hashDigest ;
       var textDigest ;
       switch (this.change) {
       case 1:
         formData.append('name', this.newdata);
         break ;
       case 2:
         formData.append('xstatus', this.newdata);
         break ;
       case 3:
         formData.append('role', this.selected_role);
         break ;
       case 4:
         formData.append('multisession', this.selected_multi);
         break ;
       case 5:
         hashDigest = sha256( userid + this.password ) ;
         textDigest = Base64.stringify(hashDigest) ;
         formData.append('password', textDigest) ;
         break ;
       }
       formData.append('login', userid)
       formData.append('sendto', this.config.sendto);
       formData.append('command', "update") ;
       axios.post(req, formData, {
                    headers: {
                        'Pswtoken': this.$store.getters.pswtoken, 
                        'Content-Type': 'multipart/form-data'
                    }
       }).then ( (response) => { 
           if (typeof response.data == "object") {
              let obj = response.data ;
              this.errormsg = "RC: " + obj.RC + " -- " + obj.RDESC  ;
              if (obj.RC == "00")  {
                this.selected_role = 0 ;
                this.login = "" ;
                this.password = "" ;
                this.r_password = "" ;
                this.brwdata = response.data.RESULT.brwdata ;
                this.brwheader = response.data.RESULT.brwheader ;
                this.mode = 'browse' ;
              }
            }
            else
              this.errormsg = "Invalid response" ;
           })
           .catch ( err => {  console.log(err) ; 
                              this.writemsg ( "RECV ERROR RESPONSE") } )  
    },
    changemode (newmod) {
      this.errormsg = "" ;
      this.mode = newmod ;
    },
    getbrowse(cmd) {
       let req = this.$store.getters.controller_url +
              "/prosw/CFG/usermgmt/" + cmd + "?swapid=" + 
              this.$store.getters.controllerid + "&seq=" + this.startseq ;
        axios.get (req, {
            timeout: 10000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           if (typeof response.data != "object") 
              this.errormsg = "Invalid RESPONSE receive (not json)" ;
           else
           if (response.data.RC != "00")
              this.errormsg = "ERROR RESPONSE " + 
                        response.data.RC + " - " + response.data.RDESC ; 
           else {
              this.errormsg = "" ;
              this.brwdata = response.data.RESULT.brwdata ;
              this.brwheader = response.data.RESULT.brwheader ;
           }
        }).catch ( (error) => { console.log(error) })
    },
    show_update() {

        var row = this.targetrow ;
        if (row == 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
        }

        let divmodal = document.getElementById( "MODAL101" ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;

        divmodal.style.top =   '100px' ;
        divmodal.style.left =  '20px' ;

        this.login = this.brwdata[row - 1].cols[1] ;
        this.newdata = "" ;
        this.password = "" ;
        this.r_password = "" ;
        this.errormsg = "" ;

        myModal.show() ;
        return 0 ;
    },
    show_report() {
        var row = this.targetrow ;
        if (row == 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
        }

        let divmodal = document.getElementById( "MODAL301" ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;

        divmodal.style.top =   '100px' ;
        divmodal.style.left =  '20px' ;

        this.login = this.brwdata[row - 1].cols[1] ;
        myModal.show() ;
        return 0 ;
    },
    do_action(cmd) {
       if (this.targetobj == 0) {
          this.errormsg = "No Target Object Please Check target row"  ;
          return ;
       }
       if (cmd == 'delete') {
         if (! confirm("Remove File ?")) return ;
       }
       let req = this.$store.getters.controller_url +
              "/prosw/CFG/usermgmt/" + cmd + "?swapid=" + 
              this.$store.getters.controllerid + "&seq=" + this.startseq +
                  "&target=" + this.targetobj ;
       axios.get (req, {
            timeout: 10000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           if (typeof response.data != "object") 
              this.errormsg = "Invalid RESPONSE receive (not json)" ;
           else
           if (response.data.RC != "00")
              this.errormsg = "ERROR RESPONSE " + 
                        response.data.RC + " - " + response.data.RDESC ; 
           else {
              this.errormsg = response.data.RDESC ;
              this.brwdata = response.data.RESULT.brwdata ;
              this.brwheader = response.data.RESULT.brwheader ;
           }
        }).catch ( (error) => { console.log(error) })
    },
    getconfig() {
      this.config = this.$store.getters.usermgmt ;
      this.userroles = this.config.userroles ;
      this.selected_role = this.userroles[0].id ;
      this.showkeys = this.config.showkeys ;
      let a = []
      for (let i = 0 ; i < this.showkeys.length ;i++) {
                 a[i] = (this.showkeys[i] == "show") ? 1 : 0 ;
      }
      this.showkey  = a ;
    },
    do_add() {
       let req = this.$store.getters.controller_url +
        "/prosw/CFG/usermgmt/save?swapid=" + this.$store.getters.controllerid + 
          "&seq=" + this.startseq ;

       if (this.login == '') {
          this.errormsg = "LOGIN IS REQUIRED" ;
          return ;
       }
       if (this.login.length < 5) {
          this.errormsg = "USER LOGIN MIN 5 CHARS" ;
          return ;
       }

       if (this.name == '') {
          this.errormsg = "NAME IS REQUIRED" ;
          return ;
       }

       if (this.selected_role == 0) {
         this.errormsg = "USER ROLE REQUIRED!"
         return ;
       }

       let k = null ;
       for (let i = 0 ; i < this.userroles.length ; i++) {
         k = this.userroles[i] ;
         if (k.id == this.selected_role)
           break ;
       }     
       if (! k || k.id != this.selected_role) {
         this.errormsg = "selection not in table: " + this.selected_role;
         return ;
       }

       if (this.password == '') {
          this.errormsg = "PASSWORD IS REQUIRED" ;
          return ;
       }

       if ( this.password.length < this.config.passwordlen) {
             this.errormsg = 'PASSWORD LENGTH MIN ' + this.config.passwordlen + ' CHARS' ;
             return ;
       }

       if (this.r_password != this.password) {
          this.errormsg = "password and confirmation not match" ;
          return ;
       }

       let hashDigest = sha256( this.login + this.password ) ;
       let textDigest = Base64.stringify(hashDigest) ;
       let formData = new FormData();

       formData.append('role', this.selected_role);
       formData.append('multisession', this.selected_multi);
       formData.append('login', this.login);
       formData.append('name', this.name);
       formData.append('password', textDigest);
       formData.append('xstatus', "new");
       formData.append('sendto', this.config.sendto);
       formData.append('command', "add") ;

       axios.post(req, formData, {
                    headers: {
                        'Pswtoken': this.$store.getters.pswtoken, 
                        'Content-Type': 'multipart/form-data'
                    }
       }).then ( (response) => { 
           if (typeof response.data == "object") {
              let obj = response.data ;
              this.errormsg = "RC: " + obj.RC + " -- " + obj.RDESC  ;
              if (obj.RC == "00")  {
                this.selected_role = 0 ;
                this.login = "" ;
                this.password = "" ;
                this.r_password = "" ;
                this.brwdata = response.data.RESULT.brwdata ;
                this.brwheader = response.data.RESULT.brwheader ;
                this.mode = 'browse' ;
              }
            }
            else
              this.errormsg = "Invalid response" ;
           })
           .catch ( err => {  console.log(err) ; 
                              this.writemsg ( "RECV ERROR RESPONSE") } )  
    },
    toggle(idx) {
      this.showkey[idx] = ! this.showkey[idx];
    },
    writemsg(err) {
      if (this.numoferr > 0) 
         this.errormsg = err + "(" + this.numoferr + ")" ;
      else
         this.errormsg = err ;
      this.numoferr ++ ;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.colpad {
    padding: 0.1rem !important ;
}
.bd-login {
    padding: 2rem;
    margin:  auto;
    border-width: 1px;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    width : auto;
}
footer {
   position: absolute ;
   bottom : 1rem ;
}
.spaceleft {
  left : 1rem ;
  position : relative;
  color: grey ;
  font-size : 14pt ;

}
.mymodal {
    background-color: yellow;
}
header {
   position: absolute ;
   top : 0.5rem ;
   height : 3rem ;
}
</style>
